import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_jasa_bkls`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_jasa_bkls/${id}`, options)
    .then(response => {
      let nota_jasa_bkls = jsona.deserialize(response.data);
      delete nota_jasa_bkls.links;
      return nota_jasa_bkls;
    });
}

function add(nota_jasa_bkls) {
  
  console.log(nota_jasa_bkls);
  const payload = jsona.serialize({
    stuff: nota_jasa_bkls,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_nota_jasa_bkls`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(nota_jasa_bkls) {
  const payload = jsona.serialize({
    stuff: nota_jasa_bkls,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_nota_jasa_bkls/${nota_jasa_bkls.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_nota_jasa_bkls/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_jasa_bkls/last/no`, options)
    .then(response => {
      return response.data;
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no
};

